import { render, staticRenderFns } from "./ServicePersonnel.vue?vue&type=template&id=2da694d8"
import script from "./ServicePersonnel.vue?vue&type=script&lang=js"
export * from "./ServicePersonnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports